import { render, staticRenderFns } from "./SalleReporteEvaluacion.vue?vue&type=template&id=73515023"
import script from "./SalleReporteEvaluacion.vue?vue&type=script&lang=js"
export * from "./SalleReporteEvaluacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports